import { render, staticRenderFns } from "./AdjustWalletDialog.vue?vue&type=template&id=153ca902"
import script from "./AdjustWalletDialog.vue?vue&type=script&lang=js"
export * from "./AdjustWalletDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports